import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  parteServicoSearchParameters: {
    numParteServico: "",
    tipoParteServico: "",
    situacao: "",
    orgaoOrigem: "",
    orgaoDestino: "",
    dtInicio: "",
    dtFim: "",
    identificador: "",
    matriculaAuditor: "",
    nomeAuditor: "",
    razaoSocial: "",
  },
  filterButton: false,
};

const parteServicoSearchSlice = createSlice({
  name: "parteServicoSearch",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.parteServicoSearchParameters = { ...action.payload };
    },
    estadoBotao(state, action) {
      state.filterButton = action.payload;
    },
    reset: () => initialState,
  },
});

export const parteServicoSearchActions = parteServicoSearchSlice.actions;

export default parteServicoSearchSlice.reducer;
